import React from 'react';
import clsx from 'clsx';
import Navigation from './VerticleNav';
import PropTypes from 'prop-types';
import useStyles from './AppSidebar.style';
import {connect, getStore, setStore} from "trim-redux";
import {Box, Drawer, Fab, Hidden} from "@mui/material";
import {Menu,X} from "lucide-react";
import {getDirection} from "../../../../config/design/theme";

const AppSidebar = (props) => {

    const navCollapsed = props.navCollapsed;
    const classes = useStyles();
    let sidebarClasses = classes.sidebarStandard;


    return (
        <>
            <Hidden lgUp>
                <Drawer
                    anchor={props.position}
                    open={navCollapsed}
                    onClose={(ev) => setStore({navCollapsed:!props.navCollapsed})}
                    style={{position: 'absolute'}}>
                    <Box height='100%' className={clsx(classes.drawerContainer,getDirection())}>
                        <Box className={clsx(classes.sidebarBg, sidebarClasses)}>
                            <Navigation />
                        </Box>
                    </Box>
                </Drawer>
                <div className={classes.mainFAB}>
                    <Fab
                        color="primary"
                        size="small"

                        onClick={() => setStore({navCollapsed:!props.navCollapsed})}
                    >
                        {
                            !!props.navCollapsed ? <X/> : <Menu/>
                        }

                    </Fab>
                </div>

            </Hidden>
            <Hidden lgDown>
                <Box height='100%' className={clsx(classes.drawerContainer,getDirection())}>
                    <Box className={clsx(classes.sidebarBg, sidebarClasses)}>
                        <Navigation />
                    </Box>
                </Box>
            </Hidden>
        </>
    );
};

const mstp = state => ({
    navCollapsed: state.navCollapsed,
    logo:state.logo
});
export default connect(mstp)(AppSidebar);

AppSidebar.defaultProps = {
    variant: '',
    position: 'left',
};

AppSidebar.propTypes = {
    position: PropTypes.string,
    variant: PropTypes.string,
};
